import { LAST_INLINE_KEY } from '@/components/Form/javascripts/inline';

const INLINES = {
  'vehicles[q]': true,
  'vehicles[sort]': LAST_INLINE_KEY,
};

export default INLINES;
